import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ButtonUI, DialogUI } from '../../Interface';
import OpWidgetGroupTable from './OpWidgetGroupTable';
import OpWidgetMultiManDialog from './OpWidgetMultiManDialog';

const GrouppedOperationDialog = (props) => {
  const { show, checkedOperations, onClose, onSave, helperData, disableBtn } = props;

  const [isEmployeeDialogOpen, setIsEmployeeDialogOpen] = useState(false);
  const [employeeGroups, setEmployeeGroups] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const handleStartClick = () => {
    const firstRelevantOp = checkedOperations.find((op) => op?.multiManOperation > 1 && op?.groupReporting === 1);

    if (firstRelevantOp) {
      const operationGroup = helperData?.operationGroup?.find((group) =>
        group.operationGroupLink?.some((link) => link.operationId === firstRelevantOp.operationId)
      );

      const usersInGroup = operationGroup?.operationGroupUserLink
        ?.filter((link) => !link.user?.groupLeader)
        ?.map((link) => link.user);

      if (usersInGroup?.length > 0) {
        setEmployeeGroups(usersInGroup);
        setIsEmployeeDialogOpen(true);
      } else {
        onSave([]);
      }
    } else {
      onSave([]);
    }
  };

  return (
    <DialogUI open={show} headerContent="Csoportosított műveletek" {...props}>
      <OpWidgetGroupTable data={checkedOperations} />

      <Box
        sx={{
          px: 4,
          mt: 8,
          display: 'flex',
          justifyContent: 'center',
          gap: 3,
        }}
      >
        <ButtonUI
          text="Indítás"
          className="bg-success"
          type="button"
          disabled={disableBtn}
          onClick={handleStartClick}
        />
        <ButtonUI
          text="Mégse"
          className=""
          color="blue-gray"
          type="button"
          variant="gradient"
          onClick={() => {
            onClose();
            setSelectedEmployees([]);
          }}
        ></ButtonUI>
      </Box>

      <OpWidgetMultiManDialog
        open={isEmployeeDialogOpen}
        handleClose={() => setIsEmployeeDialogOpen(false)}
        data={employeeGroups}
        setSelectedEmployees={setSelectedEmployees}
        handleStartOperation={() => {
          setIsEmployeeDialogOpen(false);
          onSave(selectedEmployees);
          setSelectedEmployees([]);
        }}
      />
    </DialogUI>
  );
};

export default GrouppedOperationDialog;
